<mat-form-field floatLabel="auto" appearance="outline" class="w-100 bdg-date-field">
  <mat-label>{{ label }}</mat-label>
  <input
    #nativeElement
    matInput
    [matDatepicker]="picker"
    [placeholder]="placeholder"
    autocomplete="off"
    (dateInput)="onDateInput($event)"
    [formControl]="control"
    (blur)="onBlur()"
    [errorStateMatcher]="matcher"
    [matDatepickerFilter]="filter"
    [id]="id"
    readonly="true"
    (click)="onPickerClicked()"
  />
  <mat-datepicker-toggle [class.mat-error]="error()" matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
  <mat-hint>{{ hint }}</mat-hint>
  <mat-error *ngIf="error()" [id]="id + '-error'">{{ error() }}</mat-error>
</mat-form-field>
